import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { mermaidComponents } from './markdown-mermaid.js';

/** Session text rendered as GitHub-flavoured Markdown (raw HTML is never rendered); links open outside */
const MD_COMPONENTS = {
  ...mermaidComponents,
  a({ href, children }: { href?: string; children?: React.ReactNode }) {
    return <a href={href} target="_blank" rel="noreferrer noopener" className="underline" style={{ color: 'var(--color-brand-light)' }}>{children}</a>;
  },
};

export function RichText({ text, className = '' }: { text: string; className?: string }) {
  return (
    <div className={`prose-event break-words text-sm ${className}`} style={{ color: 'var(--color-text)' }}>
      <Markdown remarkPlugins={[remarkGfm]} components={MD_COMPONENTS}>{text}</Markdown>
    </div>
  );
}

